import React from 'react'
import { ErrorHandler } from '../../components/ErrorHandler/ErrorHandler'
import { useQuery } from '@tanstack/react-query'
import { IUser } from '../../api/types/user'
import { queryUsers, usersQueryKey } from '../../api/queries'
import { UserRow } from './components/UserRow/UserRow'
import { CreateUser } from './components/CreateUser/CreateUser'
import {
  Box,
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Theme,
  Typography,
} from '@mui/material'
import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'
import { Navbar } from '../../components/Navbar/Navbar'
import { fromAxiosError } from '../../context/GlobalError'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      padding: theme.spacing(1),
      margin: theme.spacing(1),
    },
    table: {
      minWidth: 650,
      border: 'none',
    },
  })
)

export const UserIndex = () => {
  const { isLoading, error, data: users } = useQuery<IUser[]>(usersQueryKey(), queryUsers)
  const classes = useStyles()

  return (
    <>
      <Navbar />
      <ErrorHandler loading={isLoading} error={fromAxiosError(error)}>
        <Container maxWidth="md">
          <Box sx={{ textAlign: 'right' }}>
            <CreateUser />
          </Box>

          <Typography variant="h4" component="h4">
            Users
          </Typography>
          <Paper className={classes.paper}>
            {users && (
              <TableContainer>
                <Table className={classes.table} padding="none">
                  <TableHead>
                    <TableRow>
                      <TableCell align="left">Username</TableCell>
                      <TableCell align="center">Admin</TableCell>
                      <TableCell align="center">GM</TableCell>
                      <TableCell colSpan={3} />
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {users.map(user => (
                      <UserRow key={user.id} user={user} />
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </Paper>
        </Container>
      </ErrorHandler>
    </>
  )
}
